<template>
  <div>
    <b><span>Comparativo de dados:</span></b>
    <br><br>
    <v-data-table :headers="headers" :items="itens" item-key="id" />
  </div>
</template>

<script>
  export default {
      props: {
        refresh: Function,
        analises: Array
      },
      data() {
      return {
        headers: [
          { text: 'Dado', value: 'dadoComparacao' },
          { text: 'Preenchido', value: 'dadoPreenchido' },
          { text: 'Consultado', value: 'dadoConsultado' },
          { text: 'Comparativo', value: 'comparativoBureau' },
        ],
        itens: [],
        indicadorComparativo: null
      }
      },
      methods: {
        alimentarObjeto() {
          const th = this
          th.itens= []
          if(th.analises.length == 0)
            return;
  
          th.itens = JSON.parse(JSON.stringify(th.analises));
          th.itens.forEach(curr => th.normalizarCampos(curr))
        },
        normalizarCampos(curr){
          const th = this

          curr.dadoPreenchido = curr.dadoPreenchido ? curr.dadoPreenchido.toUpperCase() : curr.dadoPreenchido;
          curr.dadoConsultado = curr.dadoConsultado ? curr.dadoConsultado.toUpperCase() : curr.dadoConsultado;
          
          if (curr.dadoComparacao === 'Data de nascimento' || curr.dadoComparacao === 'Data de abertura') {
            const regexData = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

            curr.dadoPreenchido = regexData.test(curr.dadoPreenchido) ? curr.dadoPreenchido : th.$api.UI.Format.Date(curr.dadoPreenchido)
            curr.dadoConsultado = regexData.test(curr.dadoConsultado) ? curr.dadoConsultado :  th.$api.UI.Format.Date(curr.dadoConsultado)
          }
          
          if (curr.comparativoBureau === th.$api.Arrays.ComparativoBureau.find((x) => x.text == 'Conforme').value)
            th.indicadorComparativo = '🟢 '
          else if (curr.comparativoBureau === th.$api.Arrays.ComparativoBureau.find((x) => x.text == 'Não conforme').value)
            th.indicadorComparativo = '🔴 '
          else
            th.indicadorComparativo = '🟡 '

          curr.comparativoBureau = th.indicadorComparativo + (curr.mensagem === '' || curr.mensagem === null ? th.$api.Arrays.ComparativoBureau.find((x) => x.value === curr.comparativoBureau).text || curr.comparativoBureau : curr.mensagem)
        }
      }
  }
  </script>
    